// extracted by mini-css-extract-plugin
export default {"main":"Loader_main__gjYmL","two":"Loader_two__6Dqtv","one":"Loader_one__iReRq"};